import { InfoCircleIcon } from '@/components/icons';
import { DemoAccessCard } from './DemoAccessCard';

/**
 * HeroSection Component
 *
 * Landing page hero with:
 * - Animated headline and tagline
 * - Training aid disclaimer banner
 * - Demo access card
 */
export function HeroSection() {
  return (
    <section className="landing-hero">
      <h1 className="landing-hero__title animate-fadeInUp">
        Master Technical Diving
        <br />
        <span className="landing-hero__title-accent">With AI-Powered Training</span>
      </h1>
      <p className="landing-hero__tagline animate-fadeInUp stagger-1">
        Using the latest technology to reinforce the concepts critical to making Technical Divers safe.
        Interactive lessons with AI coaching adapt to your learning pace.
      </p>

      {/* Training Aid Disclaimer Banner */}
      <div className="landing-card landing-card--disclaimer animate-fadeInUp stagger-2">
        <div className="landing-disclaimer">
          <InfoCircleIcon size={24} className="landing-disclaimer__icon" />
          <div>
            <h4 className="landing-disclaimer__title">
              Training Aid &mdash; Not a Certification Course
            </h4>
            <p className="landing-disclaimer__text">
              ClosedLoopDiving provides <strong>supplementary practice</strong> for students enrolled
              in formal technical diving programs. Our courses <strong>do not license or certify</strong>{' '}
              anyone to conduct decompression dives, CCR dives, or any technical diving activities.
              All diving certification must be obtained through a{' '}
              <strong>licensed training agency</strong> (PADI, TDI, IANTD, GUE, etc.) under instructor
              supervision.
            </p>
            <p className="landing-disclaimer__text">
              <strong>Our goal:</strong> Help you master the knowledge needed to pass certification
              significantly easier through practice and reinforcement.
            </p>
          </div>
        </div>
      </div>

      {/* Demo CTA */}
      <DemoAccessCard />
    </section>
  );
}
